<template>
  <HomeFood v-if="$store.state.company.company_type === 'RESTAURANT' || $store.state.choicedCompany.company_type === 'RESTAURANT'"/>
  <!-- HomeMarketplace v-else-if="$store.state.company.block_address_navigation === 'YES_LIST'" /-->
  <HomeWhiteLabel v-else />
</template>

<script>
import HomeWhiteLabel from '@/views/HomeWhiteLabel'
// import HomeMarketplace from '@/views/HomeMarketplace'
import HomeFood from '@/views/HomeFood'
export default {
  components: {
    //HomeMarketplace, 
    HomeWhiteLabel, HomeFood
  }
}
</script>

<style>

</style>
